export class APIError extends Error {
	constructor(
		public readonly status: number,
		public readonly body?: string,
		options?: ErrorOptions
	) {
		super(`unexpected response: ${status}`, options);
	}

	isServerError(): boolean {
		return this.status / 100 == 5;
	}

	isClientError(): boolean {
		return this.status / 100 == 4;
	}
}
